import { defineStore } from "pinia";
import { ref, watch } from "vue";

import { useSpeckleStore } from "@/stores/speckle/speckle.store";
import { CameraEvent } from "@speckle/viewer";
import type { CanonicalView } from "@speckle/viewer";

type GoToViewOpts = {
  view?: CanonicalView;
  fit?: number;
  animate?: boolean;
};

export const useSpeckleCamera = defineStore("speckleCamera", () => {
  const core = useSpeckleStore();
  const isOrthoActive = ref(false);

  // Read the projection from the camera instead of trusting a mirror of it: this store outlives the
  // viewer, and both a new viewer (which starts in perspective) and recenterView's no-world-box fallback
  // change the projection without going through the setters below (RTLCA-5722).
  const syncProjection = () => {
    const camera = core.cameraRef?.renderingCamera as { isOrthographicCamera?: boolean } | undefined;
    isOrthoActive.value = !!camera?.isOrthographicCamera;
  };

  watch(
    () => core.cameraRef,
    (controller) => {
      syncProjection();
      controller?.on(CameraEvent.ProjectionChanged, syncProjection);
    },
    { immediate: true }
  );

  const setOrthoOn = () => {
    core.cameraRef?.setOrthoCameraOn();
    isOrthoActive.value = true;
    core.viewer?.requestRender?.();
  };

  const setPerspectiveOn = () => {
    core.cameraRef?.setPerspectiveCameraOn?.();
    isOrthoActive.value = false;
    core.viewer?.requestRender?.();
  };

  const toggleProjection = () => {
    isOrthoActive.value ? setPerspectiveOn() : setOrthoOn();
  };

  const goToTopView = async ({ view = "top", fit = 1.2, animate = true }: GoToViewOpts = {}) => {
    const cam = core.cameraRef;
    if (!cam) return;

    // core.cameraRef?.stopTransitions?.();

    // cam?.setOrthoCameraOn();
    cam?.setCameraView(view, animate, fit);

    // core.viewer?.zoomExtents?.();
    // core.cameraRef?.zoomExtents?.();
    // core.cameraRef?.setCameraView("3D", true, fit);

    // Ortho first for plan view
    // cam.setOrthoCameraOn();
    // isOrthoActive.value = true;

    // Fit/center via setCameraView’s fit param (no zoomExtents needed)

    // await Promise.resolve(cam.setCameraView(view, animate, fit));
    // cam.setCameraView(view, animate, fit)
    // cam.setCameraView("3d", true, fit)

    // cam.enabled = true; // turn the CameraController back on
    // cam.controls && (cam.controls.enabled = true); // re-enable the underlying controls

    // core.viewer?.zoomExtents?.();
    // core.cameraRef?.zoomExtents?.();
    core.cameraRef?.setCameraView("3D", true, fit);
    // core.cameraRef?.setOrthoCameraOn();
    core.viewer?.requestRender?.();
  };

  return {
    isOrthoActive,

    toggleProjection,
    goToTopView,
    setOrthoOn,
  };
});
